// TODO: get STRIVE Super Users from Arcimedes
export default [
    'Auto',
    'Evan Perez',
    'Jennifer Pierson',
    'Jason Vitorino',
    'Mike Mulcahy',
    'Shannon Nettles',
    'Tim Birdsong',
    'Ted Parrish',
    'Will Meachum',
];